var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('router-view',{attrs:{"role":"main"}}),(_vm.$route.path === '/portfolio' || _vm.$route.path === '/')?_c('FooterComponent'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }